import { useEffect, useState } from "react";
import { Notification, Refresh } from "iconsax-react";
import { useTranslation } from "react-i18next";
import DBModal from "../../component/global/DBModal";
import { incentivesApi } from "./api";
import { RewardStatus } from "./Rewards";

export default function NotificationsCenter({ show, onHide }) {
    const { t } = useTranslation();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const load = () => {
        setLoading(true);
        setError(false);
        incentivesApi
            .notifications()
            .then(setRows)
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    };
    useEffect(() => {
        if (show) load();
    }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

    const markRead = (row) => {
        if (row.read) return;
        setRows((current) =>
            current.map((item) =>
                item.id === row.id ? { ...item, read: true } : item
            )
        );
        incentivesApi.markNotificationRead(row.id).catch(() => {});
    };
    return (
        <DBModal
            show={show}
            onHide={onHide}
            minWidth={480}
            className="incentive-notifications"
            ariaLabelledby="incentive-notifications-title"
        >
            <DBModal.Header
                closeBtn={onHide}
                title={
                    <span>{t("incentives.notifications.title")}</span>
                }
            />
            <DBModal.Content>
                {loading ? (
                    <p role="status">{t("loading")}</p>
                ) : error ? (
                    <div role="alert" className="incentive-state">
                        <p>{t("incentives.notifications.error")}</p>
                        <button type="button" onClick={load}>
                            <Refresh size={18} aria-hidden="true" />
                            {t("incentives.retry")}
                        </button>
                    </div>
                ) : rows.length === 0 ? (
                    <div className="incentive-state">
                        <Notification size={28} aria-hidden="true" />
                        <p>{t("incentives.notifications.empty")}</p>
                    </div>
                ) : (
                    <ul>
                        {rows.map((row) => (
                            <li
                                key={row.id}
                                className={row.read ? "" : "unread"}
                            >
                                <button
                                    type="button"
                                    onClick={() => markRead(row)}
                                >
                                    <strong>{row.title}</strong>
                                    <span>{row.message}</span>
                                    {row.reward_status && (
                                        <RewardStatus
                                            status={row.reward_status}
                                        />
                                    )}
                                    <time dateTime={row.created_at}>
                                        {row.created_at_display ||
                                            row.created_at}
                                    </time>
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </DBModal.Content>
        </DBModal>
    );
}
